import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: any) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    '& .mainHead': {
      marginTop: 'unset !important',
      textAlign: 'left !important',
      color: '#000000',
      fontSize: '1.5rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
    },
    '& .headerAndInputs': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& .inputWrap': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: '4px !important',
    },
    '& .latitudeColumn, .longitudeColumn': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '& .latitudeColumn .headText, .longitudeColumn .headText': {
      marginBottom: '6px',
      marginTop: 'unset',
      color: '#949494',
    },
    '& .latitudeInput, .longitudeInput': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      marginBottom: '12px',
      '& .indexes': {
        color: '#FD0B0B',
        fontWeight: 'bold',
        marginLeft: '4px',
      },
      '& .MuiFormControl-root': {
        backgroundColor: '#ffffff',
        marginTop: 'unset !important',
        marginBottom: 'unset !important',
        '& .MuiInputBase-root': {
          '& input': {
            padding: '12px',
          },
        },
      },
    },
    '& .radioBtnWrap': {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '16px',
      '& .MuiFormControl-root': {
        '& .MuiFormGroup-row': {
          display: 'flex !important',
          flexDirection: 'row !important',
          gap: '12px !important',
          flexWrap: 'nowrap !important',
          '& .MuiFormControlLabel-root': {
            '& .MuiTypography-root': {
              textAlign: 'left',
              color: '#000000',
              fontSize: '0.95rem',
              lineHeight: '16px',
            },
          },
        },
      },
    },
    '& .MuiGrid-root:first-child': {
      paddingLeft: '0 !important',
      paddingTop: '0 !important',
      '& .MuiPaper-root': {
        background: 'transparent !important',
        border: 'none !important',
        boxShadow: 'unset !important',
      },
    },
    '& .MuiGrid-root:last-child': {
      padding: '0 !important',
      '& .MuiPaper-root': {
        height: '100%',
        padding: 'unset',
        '& svg': {
          width: '100%',
          height: '100%',
        },
      },
    },
    '& .resetBtnWrap': {
      display: 'flex',
      justifyContent: 'flex-start',
    }
  },
  map: {
    width: "100%",
    height: "400px",
  },
}));
